import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../parts/SvgIcon";
import { activeChips, removeChip } from "../door-access-utils";

const chipLabel = (chip, t, filters) => {
  if (chip.key === "range")
    return t(`doorAccess.filters.range.${filters.range}`);
  if (chip.key === "member")
    return t("doorAccess.chips.member", { name: chip.label });
  if (chip.key === "door") return chip.label;
  if (chip.key === "result") {
    return t("doorAccess.chips.result", {
      result: t(`doorAccess.filters.result.${chip.value}`),
    });
  }
  return t("doorAccess.chips.unmatchedOnly");
};

const ActiveChips = ({ filters, onChange, onClear }) => {
  const { t } = useTranslation("coaching-portal");
  const chips = activeChips(filters);
  if (!chips.length) return null;

  return (
    <div className="door-chips">
      <span className="door-chips__label">
        {t("doorAccess.chips.filteredBy")}
      </span>
      {chips.map((chip) => (
        <button
          key={`${chip.key}-${chip.id || chip.value || ""}`}
          type="button"
          className="door-chip"
          aria-label={`${t("doorAccess.chips.remove")}: ${chipLabel(chip, t, filters)}`}
          onClick={() => onChange(removeChip(filters, chip))}
        >
          {chipLabel(chip, t, filters)}
          <SvgIcon src="/img/new-icons/cross.svg" useCurrentColor />
        </button>
      ))}
      <button
        type="button"
        data-button-type="text"
        sz="small" //NOSONAR
        onClick={onClear}
      >
        <span>{t("doorAccess.chips.clear")}</span>
      </button>
    </div>
  );
};

export default ActiveChips;
